<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzTitle="Pesquisas" nzSubtitle=" - Pesquisas realizadas.">
        <nz-page-header-extra>
            <!--<button nz-button nzType="primary" routerLink="lancamento"><i nz-icon nzType="plus"></i> Cadastrar</button>-->
        </nz-page-header-extra>
    </nz-page-header>
    <nz-row [nzGutter]="14">
        <nz-col [nzSpan]="12">
            <nz-skeleton size="small" [nzLoading]="loadingQtdPesquisas" [nzParagraph]="{ rows: 1 }" nzActive="true">
            </nz-skeleton>
            <nz-card *ngIf="!loadingQtdPesquisas">
                <nz-statistic [nzValueStyle]="{ color: '#3F8600' }" [nzValue]="qtdPesquisasMes" nzTitle="Qtd. Pesquisas do Mês">
                </nz-statistic>
                <small style="float: left; margin-top: 10px;"><a (click)="openHistoricoPesquisasMensal()"><i nz-icon nzType="plus" nzTheme="outline"></i> Ver Histórico</a></small>
                <small style="float: right; margin-top: 10px;"><i nz-icon nzType="calendar" nzTheme="outline"></i> {{dataAtual | date: 'MM/yyyy'}}</small>
            </nz-card>
    
        </nz-col>
        <nz-col [nzSpan]="12">
            <nz-skeleton size="small" [nzLoading]="loadingQtdPesquisas" [nzParagraph]="{ rows: 1 }" nzActive="true">
            </nz-skeleton>
            <nz-card *ngIf="!loadingQtdPesquisas">
                <nz-statistic [nzValueStyle]="{ color: '#3F8600' }" [nzValue]="qtdPesquisas" nzTitle="Pesquisas Realizadas Hoje">
                </nz-statistic>
                <small style="float: right; margin-top: 10px;"><i nz-icon nzType="calendar" nzTheme="outline"></i> {{dataAtual | date: 'dd/MM/yyyy HH:mm:ss'}}</small>
            </nz-card>
    
        </nz-col>
    </nz-row>
    <div nz-row nzGutter="8">
        <div nz-col nzSpan="24">
            <nz-divider></nz-divider>
        </div>

        <div nz-col nzSpan="12" style="margin-top:20px;">


            <nz-table #basicTable (nzQueryParams)="onQueryParamsChangeMP($event)" nzSize="small" [(nzData)]="maisPesquisadas" [nzLoading]="MPloading">
                <thead>
                    <tr>
                        <th colspan="2" style="text-align:center;">MAIS PESQUISADAS</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colspan="2">
                            <div nz-row nzGutter="8">
                                <div nz-col nzSpan="9">
                                    <input nz-input type="date" [(ngModel)]="dataInicial" placeholder="Data Inicial" />
                                </div>
                                <div nz-col nzSpan="9">
                                    <input nz-input type="date" [(ngModel)]="dataFinal" placeholder="Data Inicial" />
                                </div>
                                <div nz-col nzSpan="6">
                                    <button nz-button (click)="getMaisPesquisadas()" [disabled]="!dataInicial || !dataFinal" nzType="primary" nzBlock>Filtrar</button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <ng-template ngFor let-data [(ngForOf)]="basicTable.data">
                        <tr>
                            <td>{{data.pesquisa}}</td>
                            <td>{{data.qtd}}</td>
                        </tr>
    
                    </ng-template>
                </tbody>
            </nz-table>
        </div>
    
        <div nz-col nzSpan="12">
            <nz-table #basicTable2 style="margin-top:20px;" (nzQueryParams)="onQueryParamsChangePH($event)" nzSize="small" [(nzData)]="pesquisasHoje" [nzLoading]="PHloading">
                <thead>
                    <tr>
                        <th colspan="2" style="text-align:center;">Pesquisas (Hoje)</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-data [(ngForOf)]="basicTable2.data">
                        <tr>
                            <td>{{data.pesquisa}}</td>
                            <td style="text-align: center;">{{data.created_at | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                        </tr>
    
                    </ng-template>
                </tbody>
            </nz-table>
        </div>
    </div>
</div>

<nz-modal [(nzVisible)]="isVisibleHistorico" nzCentered="true" [nzFooter]="null" [nzTitle]="'Histórico de Pesquisas Mensais'" (nzOnCancel)="closeHistorico()" nzWidth="600px">
    <ng-container *nzModalContent>
    <app-chart-historico-pesquisas-mensal></app-chart-historico-pesquisas-mensal>
    </ng-container>
</nz-modal>